import { SectionDefinition } from "../../../../../model/service-request/section-definition";
import { Attribute } from "../../../../../model/service-request/attribute";
import { DynamicFieldItem } from "../../../../../model/dynamic-forms";

export function isFieldFilled(item?: DynamicFieldItem): boolean {
	if (!item) return false;
	const value = item.fieldValue;
	if (value === null || value === undefined) return false;
	if (typeof value === "string") return value.trim().length > 0;
	if (Array.isArray(value)) return value.length > 0;
	return true; // number, boolean (incl. false), File, Date, etc.
}

function visibleAttributes(section: SectionDefinition): Attribute[] {
	return section.attributeDefinitions.filter(a => a.isEnabled !== false && a.isHidden !== true);
}

export function getMissingRequiredFieldIds(section: SectionDefinition, values: DynamicFieldItem[]): string[] {
	const byId = new Map(values.map(v => [v.fieldId, v]));
	return visibleAttributes(section)
		.filter(a => a.isRequired)
		.filter(a => !isFieldFilled(byId.get(a.id)))
		.map(a => a.id);
}

export function isSectionValid(section: SectionDefinition, values: DynamicFieldItem[]): boolean {
	return getMissingRequiredFieldIds(section, values).length === 0;
}
